enum EventEnum {
  API_REQUEST_ENDED = 'API_REQUEST_ENDED',
  API_REQUEST_STARTED = 'API_REQUEST_STARTED',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
}

export default EventEnum;
